





















import Vue, { PropType } from 'vue'
import {
  SubRegionCrud,
  Region,
  MessengerConfig,
  TableHeader,
} from '@/utils/interfaces'
import { getSubregions } from '@/api/Address/address'
import { number } from '@/utils/validators'
export default Vue.extend({
  props: {
    region: Object as PropType<Region>,
    messenger_config: Object as PropType<MessengerConfig>,
  },
  data() {
    return {
      items: [] as SubRegionCrud[],
      loading: false,
      rules: {
        number: (v: number | string) =>
          number((!v && v !== 0 ? '' : v).toString()) ||
          this.$t('must-be-a-number'),
        greaterThan: (v: number) => v >= 0 || this.$t('must-be-non-negative'),
      },
      headers: [
        {
          text: this.$t('municipality'),
          value: 'subregion_name',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
        {
          text: this.$t('commission') + ' ($)',
          value: 'fixed_commission',
        },
      ] as TableHeader[],
    }
  },
  methods: {
    activeAll(): void {
      this.items.forEach(item => {
        item.is_active = true
      })
    },
    deactiveAll(): void {
      this.items.forEach(item => {
        item.is_active = false
      })
    },
    setAll(value: number): void {
      this.items.forEach(item => {
        item.fixed_commission = value
      })
    },
    getData(): SubRegionCrud[] {
      return this.items
    },
    updateCommissions(): void {
      const subregions = this.items.map(subregion => subregion.subregion)
      const commissions = this.messenger_config.subregion_commissions.map(
        commission => commission.subregion,
      )
      subregions.forEach((id, index) => {
        const commissionIndex = commissions.indexOf(id)
        if (commissionIndex !== -1) {
          this.items.splice(
            index,
            1,
            this.messenger_config.subregion_commissions[commissionIndex],
          )
        }
      })
    },
  },
  async mounted() {
    try {
      this.loading = true
      const response = await getSubregions({
        country__name: 'Cuba',
        region: this.region.id,
        limit: 100,
      })
      const items = response.data.results.map(subregion => ({
        subregion: subregion.id,
        subregion_name: subregion.name,
        fixed_commission: 0,
        is_active: false,
      }))
      for (let index = 0; index < items.length; index++) {
        const element = items[index]
        this.items.push(element)
      }
    } finally {
      this.loading = false
    }
    if (this.messenger_config) {
      this.updateCommissions()
    }
  },
})
